import { store } from '../../configureStore';
import * as constants from './constants';
import { redirectToMV } from '../../redirectionMV';
import { getSession } from '../../components/common/Helpers/index';

export const updateProgressStepMV = (progressStep, action) => {
  if (progressStep) {
    store.dispatch({ type: `UPDATE_${progressStep?.toUpperCase()}_MV`, response: action });
  }
  updateCurrentViewMV(progressStep);
};

export const updateCurrentViewMV = (currentView) => {
  const { processStepsMV } = store.getState();
  const orderSubmitted = getSession('OrderSubmitted');
  let curView = {};
  if (processStepsMV && Object.keys(processStepsMV).length > 0) {
    Object.keys(processStepsMV).forEach((view) => {
      if (view?.toLowerCase() === currentView?.toLowerCase()) {
        curView = processStepsMV[view];
        return true;
      }
      return false;
    });
  }
  store.dispatch({ type: constants.UPDATE_CURRENT_VIEW_MV, response: curView });
  // if (history) redirectToMV(curView.nextViewPage, history);
  if (orderSubmitted === 'Y' && curView.currentStep) {
    redirectToMV(`${curView.currentStep.toLowerCase()}.html`);
  }
};
